import React from 'react';
import { Row, MenuProps } from 'antd';
import COBarChart from 'views/Dashboard/COBarChart';
import BusinessModalDropdown from './BusinessModalDropdown';
import { DashboardViewProps } from 'enums/DashboardViewEnums';
import { DownloadFileName } from 'enums/GraphDropdownEnums';
import styles from './Dashboard.module.scss';
import { CategoryOptions, EmissionState } from '.';
import { PaginationConfig } from 'models/PaginationConfig/paginationConfig.model';
import { EmissionParams } from 'services/DashboardService/dashboard.service';

interface ProductEmissionChartsProps {
  productCarbonFootPrintData: CategoryOptions[];
  productEmissionLoading: boolean;
  handleSortProductEmission: MenuProps['onClick'];
  downloadProductEmissionCSV: () => void;
  sortedProductEmissionList: EmissionState;
  productEmissionPagination: PaginationConfig;
  handleChangeBusinessModelProductEmission: (params: EmissionParams) => void;
  annualProductChartData: CategoryOptions[];
  productEmissionAnnualLoading: boolean;
  handleSortAnnualEmission: MenuProps['onClick'];
  downloadAnnualEmissionCSV: () => void;
  sortedAnnualEmissionList: EmissionState;
  productEmissionAnnualPagination: PaginationConfig;
  handleChangeBusinessModelAnnualEmission: (params: EmissionParams) => void;
}

const ProductEmissionCharts: React.FC<ProductEmissionChartsProps> = ({
  productCarbonFootPrintData,
  productEmissionLoading,
  handleSortProductEmission,
  downloadProductEmissionCSV,
  sortedProductEmissionList,
  productEmissionPagination,
  handleChangeBusinessModelProductEmission,
  annualProductChartData,
  productEmissionAnnualLoading,
  handleSortAnnualEmission,
  downloadAnnualEmissionCSV,
  sortedAnnualEmissionList,
  productEmissionAnnualPagination,
  handleChangeBusinessModelAnnualEmission,
}) => {
  return (
    <Row>
      <div className={styles.chartContainer}>
        <div className={styles.productChartHeading}>
          <h3>{DashboardViewProps.CHART_ONE_HEADING}</h3>
          <BusinessModalDropdown
            onDropdownOptionChange={handleChangeBusinessModelProductEmission}
            pagination={productEmissionPagination}
            paramsState={sortedProductEmissionList.params}
          />
        </div>
        <div className={styles.productChartContainer}>
          <COBarChart
            data={productCarbonFootPrintData}
            loading={productEmissionLoading}
            graphDropDownProps={{
              handleSort: handleSortProductEmission,
              downloadCsv: downloadProductEmissionCSV,
            }}
            isSort={
              sortedProductEmissionList?.params?.is_asc === true ||
              sortedProductEmissionList?.params?.is_asc === false
            }
            selectedOption={
              sortedProductEmissionList?.params?.is_asc === true
                ? 'true'
                : sortedProductEmissionList?.params?.is_asc === false
                ? 'false'
                : 'default'
            }
            graphName={DownloadFileName.COMPANY_PRODUCTS_EMISSION}
          />
        </div>
        <div className={styles.productAnnualChartHeading}>
          <h3>{DashboardViewProps.CHART_TWO_HEADING}</h3>
          <BusinessModalDropdown
            onDropdownOptionChange={handleChangeBusinessModelAnnualEmission}
            pagination={productEmissionAnnualPagination}
            paramsState={sortedAnnualEmissionList.params}
          />
        </div>
        <div className={styles.productAnnualChartContainer}>
          <COBarChart
            data={annualProductChartData}
            loading={productEmissionAnnualLoading}
            graphDropDownProps={{
              handleSort: handleSortAnnualEmission,
              downloadCsv: downloadAnnualEmissionCSV,
            }}
            isSort={
              sortedAnnualEmissionList?.params?.is_asc === true ||
              sortedAnnualEmissionList?.params?.is_asc === false
            }
            selectedOption={
              sortedAnnualEmissionList?.params?.is_asc === true
                ? 'true'
                : sortedAnnualEmissionList?.params?.is_asc === false
                ? 'false'
                : 'default'
            }
            graphName={DownloadFileName.COMPANY_ANNUAL_EMISSION}
          />
        </div>
      </div>
    </Row>
  );
};

export default ProductEmissionCharts;
